module.exports = __webpack_public_path__ + "static/img/bg_editor.d762987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ibroadcast/bg_editor.jpg
// module id = 845
// module chunks = 0